const BOOKING_BASE = "https://recreation.exploremoreil.com/IllinoisWeb";

export default {
  buildBookingUrl({ site }) {
    // Illinois accepts the park/facility route but does not populate dates
    // from the hash query on a fresh navigation.
    return site.reserveUrl;
  },
  buildPreviewUrl(site, facility) {
    const placeId = facility?.extraAttributes?.placeId;
    return placeId ? `${BOOKING_BASE}/#!park/${placeId}` : site.reserveUrl;
  },
  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "ignored",
          notes: "Select arrival on the booking website.",
        },
        departureDate: {
          status: "ignored",
          notes: "Select departure on the booking website.",
        },
        ref: {
          status: "ignored",
          notes: "Select the numbered unit on the booking website.",
        },
        partySize: {
          status: "ignored",
          defaultValue: 1,
          notes: "Select party size on the booking website.",
        },
      },
    };
  },
};
